import { useFetcher } from '@remix-run/react'
import { useEffect } from 'react'
import { ArticleGrid } from './articleGrid'
import { ArticlePage } from './articlePage'
import { ProductCard } from './productCard'
import { H3, Paragraph } from './typography'

export function CourseDateList() {
	const fetcher = useFetcher()

	useEffect(() => {
		if (fetcher.state === 'idle' && fetcher.data === undefined) {
			fetcher.load('/api/masterclasses')
		}
	}, [])

	const data = fetcher.data ?? []

	if (fetcher.data) {
		const {
			products: {
				products: { edges: products },
			},
		} = fetcher.data

		return (
			<ArticlePage>
				<ArticleGrid>
					<ProductCard products={products} />
				</ArticleGrid>
			</ArticlePage>
		)
	}

	return <Paragraph>Loading course dates</Paragraph>
}
